define([
	"dojo/_base/declare",
	"csi/form/Widget"
], function(declare,Widget) {

	return declare(Widget, {
		// Boolean: write only visible fields
		bWriteVisible: true,

		// Object: map of attributes to expressions indicating if should be hidden
		_hideExpressions: {
			C8User: "!attr('EE')",
			DBType: "find(attr('EE'),'Database') < 0",
			DBHost: "(find(attr('EE'),'Database') < 0) || (attr('DBT') == '') || (attr('DBT') == 'C8') || (attr('DBT') == 'ODBC')",
			DBUser: "(find(attr('EE'),'Database') < 0) || (attr('DBT') == '') || (attr('DBT') == 'C8')",
			DBPass: "(find(attr('EE'),'Database') < 0) || (attr('DBT') == '') || (attr('DBT') == 'C8')",
			DBName: "(find(attr('EE'),'Database') < 0) || (attr('DBT') == '') || (attr('DBT') == 'C8')",
			Folder: "!attr('EE') || attr('EE') == 'Natific ASAP'",
			ValidateNodes: "!attr('EE') || attr('EE') == 'Natific ASAP'",
			LogDebugInfo: "!attr('EE') || attr('EE') == 'Natific ASAP'",
			DeletedNodesDays: "!attr('EE') || attr('EE') == 'Natific ASAP' || attr('EE') == 'Excel'",
			StoredProcedureName: "attr('EE') != 'Database  - Synchronized'",
			Timeout:  "attr('EE') != 'Database  - Synchronized'",
			Delimiter:  "attr('EE') != 'CSV'",
			ByteOrderMark:  "find(attr('EE'),'CSV') < 0",
			ReplaceLineBreaks: "attr('EE') != 'CSV'",
            URL:  "attr('EE') != 'Natific ASAP'",
            ApiKey:  "attr('EE') != 'Natific ASAP'"
		},

		// Object: map of required attributes expressions - visibility above trumps required status
		_requiredExpressions: {
			DBHost: "attr('DBT') != 'ODBC'",
			DBUser: "attr('DBT') != 'ODBC'",
			DBPass: "attr('DBT') != 'ODBC'",
			DBName: "true",
			Folder: "find(attr('EE'),'Database') < 0",
			StoredProcedureName: "attr('EE') == 'Database  - Synchronized'",
			Timeout: "attr('EE') == 'Database  - Synchronized'",
			Delimiter: "attr('EE') == 'CSV'",
            URL:  "attr('EE') == 'Natific ASAP'",
            ApiKey:  "attr('EE') == 'Natific ASAP'"
		},

		getFormContext: function() {
			// summary: resolve ExternalExporter and DBType values to simplify expressions
			var	ctx = this.inherited(arguments);
			var	node = ctx.getNode();
			var	ee = ctx.cache.getNode(node.ExternalExporter, true);
			var	eep = ctx.cache.getNode(node.ExternalExporterParameters, true);
			node.EE = ee ? ee.$Name : "";
			node.DBT = eep ? eep.DBType : "";
			return ctx;			
		}
	});
});